import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import DealReviewStats from './DealReviewStats';

/**
 * 상품리뷰 평점 컴포넌트
 */
function DealReview({ reviewType, representativeReview = {} }) {
  const {
    data: {
      reviewAvgScore,
      reviewCount,
      contents,
      optionName,
      representReviewSurveyInfos,
    } = {},
  } = representativeReview;
  if (!reviewAvgScore || !reviewCount) {
    return null;
  }

  const [isOpen, setOpen] = useState(false);
  const reviewBtn = useRef(null);

  const onToggleReview = e => {
    e.preventDefault();
    setOpen(!isOpen);
  };

  const onShowReview = e => {
    e.preventDefault();
    TMON.oApp.enableTab({ sTabId: 'review', bScrollToTab: true });
  };

  useEffect(() => () =>
    reviewBtn.current.removeEventListener('click', onToggleReview)
  );

  return (
    <div className="deal_review">
      {TMON.oApp.sPlatform !== 'PW' && (
        <div className="info_unit_title">
          <h3 className="title">상품리뷰</h3>
        </div>
      )}
      <div className="info_unit_contents">
        <button
          type="button"
          className="button_review_average"
          aria-label="상품리뷰 보기"
          onClick={onShowReview}
        >
          <div
            className="grade_average"
            aria-label={`구매후기 5점 만점 중 ${reviewAvgScore}점 ${reviewCount}명 참여`}
          >
            <div className="grade_average_points" tabIndex="-1">
              {Array.from({ length: 5 }, (x, i) => (
                <span className="grade_average_point" key={reviewAvgScore + i}>
                  <span
                    className={
                      reviewAvgScore < i
                        ? 'grade_average_mark '
                        : `grade_average_mark mark_${
                            reviewAvgScore >= i + 1
                              ? 100
                              : ((reviewAvgScore * 10) % 10) * 10
                          }`
                    }
                  />
                </span>
              ))}
            </div>
            <span className="grade_average_score" tabIndex="-1">
              {reviewAvgScore}
            </span>
            <span className="grade_average_count" tabIndex="-1">
              <span className="num">
                {TMON.util.numberWithComma(reviewCount)}
              </span>
              <span className="text">개의 리뷰</span>
            </span>
          </div>
        </button>
        {representReviewSurveyInfos && representReviewSurveyInfos.length ? (
          <DealReviewStats
            representReviewSurveyInfos={representReviewSurveyInfos}
          />
        ) : (
          ''
        )}
        {TMON.oApp.sPlatform !== 'PW' && reviewType !== 'S' && contents && (
          <div
            className={`button_review ${isOpen ? 'open' : ''}`}
            role="button"
            ref={reviewBtn}
            onClick={onToggleReview}
          >
            <p className="review_text">{contents}</p>
            {optionName && <span className="review_product">{optionName}</span>}
          </div>
        )}
      </div>
    </div>
  );
}

DealReview.propTypes = {
  reviewType: PropTypes.string,
  representativeReview: PropTypes.shape({
    data: PropTypes.shape({
      reviewAvgScore: PropTypes.number,
      reviewCount: PropTypes.number,
      reviewContents: PropTypes.string,
      optionName: PropTypes.string,
    }),
  }),
};

export default DealReview;
